const URL_RE = /https?:\/\/[^\s<>"'\)\]]+/gi;
const TRAILING_PUNCT = /[.,;:)\]'"]+$/;

export function extractHttpUrls(text: string): string[] {
  if (!text) return [];
  const found: string[] = [];
  const seen = new Set<string>();
  const matches = text.match(URL_RE) || [];
  matches.forEach((raw) => {
    const cleaned = raw.replace(TRAILING_PUNCT, '');
    const key = cleaned.toLowerCase();
    if (!cleaned || seen.has(key)) return;
    seen.add(key);
    found.push(cleaned);
  });
  return found;
}

export function urlFromInternetShortcut(text: string): string | null {
  const match = text.match(/^\s*URL\s*=\s*(\S+)/im);
  if (!match) return null;
  return extractHttpUrls(match[1])[0] || match[1].replace(TRAILING_PUNCT, '').trim() || null;
}

export function clipboardImageFiles(clipboard: DataTransfer | null): File[] {
  if (!clipboard) return [];
  const fromFiles = Array.from(clipboard.files || []).filter((file) => file.type.startsWith('image/'));
  if (fromFiles.length > 0) return fromFiles;
  return Array.from(clipboard.items || [])
    .filter((item) => item.kind === 'file' && item.type.startsWith('image/'))
    .map((item) => item.getAsFile())
    .filter((file): file is File => Boolean(file));
}

export async function splitDroppedInvoiceFiles(files: File[]): Promise<{ files: File[]; urls: string[] }> {
  const kept: File[] = [];
  const urls: string[] = [];
  await Promise.all(
    files.map(async (file) => {
      if (file.name.toLowerCase().endsWith('.url')) {
        const url = urlFromInternetShortcut(await file.text());
        if (url) urls.push(url);
        return;
      }
      kept.push(file);
    })
  );
  return { files: kept, urls };
}
